<template>
  <v-col class="home" align-center>
    <v-stepper v-model="activeStep" class="stepper" :non-linear="true" @change="onStepChange">
      <div :class="['journeyNavigation', {'journeyStart': Number(activeStep) === 1, 'journeyFollowing': Number(activeStep) > 1}]">
        <v-stepper-header class="stepper-header">
          <v-stepper-step :complete="activeStep > 1" step="1" editable>{{ $t("ORDER_STEP_1") }}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="activeStep > 2" step="2" :editable="allowStep2And3" edit-icon="photo_library">
            {{ $t("ORDER_STEP_2") }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="activeStep > 3" step="3" :editable="allowStep2And3">
            {{ $t("ORDER_STEP_3") }}
          </v-stepper-step>
        </v-stepper-header>
        <ShopNavigationActions v-if="Number(activeStep) > 1" :step="Number(activeStep)" class="d-md-none"/>
      </div>

      <v-stepper-items>
        <v-stepper-content step="1">
          <CodeSubmission/>
        </v-stepper-content>

        <v-stepper-content step="2">
          <ImagePresentation ref="imagePresentation"/>
        </v-stepper-content>

        <v-stepper-content step="3">
          <Products/>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-col>
</template>

<script lang="ts">
import Component from "vue-class-component";
import CodeSubmission from "@/views/CodeSubmission.vue";
import ImagePresentation from '@/views/ImagePresentation.vue';
import Products from "@/views/Products.vue";
import BasicComponent from "@/global/BasicComponent";
import ShopNavigationActions from "@/components/ShopNavigationActions.vue";

@Component({
  components: {ShopNavigationActions, CodeSubmission, Products, ImagePresentation}
})
export default class Home extends BasicComponent {

  code: string = "";
  loading: boolean = false;

  created() {

  }

  mounted() {

  }

  get activeStep() {
    return this.$route.query.step;
  }

  set activeStep(val) {
    this.setStep(val);
  }

  onStepChange(step) {
    if (step !== '1') {
      this.removeCodesFromQueryParams()
    }
  }

  get allowStep2And3() {
    const modifiedCodes = this.$store.getters.step === '1' && !this.codesInputMatchesSelection
    return this.hasImages && !modifiedCodes
  }

}
</script>
<style scoped lang="scss">

@use "../stylesheets/Variables.scss";

.home {
  width: 100%;
  padding-top: 0;

  @media (max-width: 599px) {
    padding-inline: 4px;
  }
}
</style>

<style lang="scss">
@use "../stylesheets/Variables.scss" as *;

.home {
  .stepper {
    min-height: 100%;
    box-shadow: none !important;
    background-color: transparent !important;

    .journeyNavigation {
      display: flex;
      justify-content: center;
      padding: 0 16px;
      margin: 0 0 16px;
      background: $shop-white;
    }

    .stepper-header {
      width: 100%;
      max-width: 900px;
      margin-inline: auto;
    }

    .stepper-header {
      height: auto;
      min-height: 48px;
      padding: 0;
      box-shadow: none;
      .v-stepper__step {
        padding: 10px 8px;
      }
      .v-divider {
        margin: 0 8px;
      }
    }

    @media (min-width: 960px) {
      .stepper-header {
        flex-wrap: nowrap;
        min-width: max-content;
        .v-stepper__step {
          flex-shrink: 0;
        }
        .v-stepper__label {
          white-space: nowrap;
        }
      }
    }

    @media (max-width: 959px) {
      .journeyNavigation {
        display: block;
        padding: 0 8px;
        margin-bottom: 8px;
      }
      .journeyFollowing .stepper-header {
        display: none;
      }
      .journeyStart .stepper-header {
        width: 100%;
      }
      .v-stepper__content {
        padding-top: 8px;
      }
    }

    @media (max-width: 599px) {
      .journeyNavigation {
        padding-inline: 0;
      }
      .stepper-header {
        min-height: 44px;
        .v-stepper__step {
          padding: 8px 4px;
        }
        .v-divider {
          margin: 0 4px;
        }
        .v-stepper__label {
          display: flex;
          font-size: 11px;
        }
        .v-stepper__step__step {
          margin-right: 5px;
        }
      }
    }

    .v-stepper__content {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .v-stepper, .v-stepper__items, .v-stepper__content, .v-stepper__wrapper {
    overflow: visible !important;
  }
}
</style>
